module.exports = __webpack_public_path__ + "static/img/ico-05.b4be5487.png";